// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    font-family: Arial, sans-serif;
    background-color: #f4f4f4;
    color: aliceblue;
    margin: 0;
    padding: 0;
    height: 100vh;
    font-size: 15px;
    font-weight: bold;
    
}

.dot{
    width: 30%;
}
.success_page {
    display: flex;
    justify-content: center; /* Horizontally center the content */
    align-items: center; /* Vertically center the content */
    height: 100vh;
}

.container {
    display: flex;
    flex-direction: column;
    align-items: center; /* Vertically center the content */
    background-color: #8c00ff;
    border-radius: 10px;
    padding: 50px 30px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
    max-width: 767px;
    width: 100%;
}

.logo img {
    width: 280px;
    margin-bottom: 20px;
}

.success_page h1 {
    font-size: 28px; /* Adjust font size as needed */
    margin-bottom: 10px; /* Optional: Adjust margin */
}

@media (max-width: 767.98px) {
    .logo img {
        width: 175px;
        margin-bottom: 10px;
    }
    .success_page h1 {
        font-size: 24px; /* Adjust font size as needed */
    }
    .success_page .container {
        padding: 40px 15px;
        max-width: 80%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,aAAa;IACb,eAAe;IACf,iBAAiB;;AAErB;;AAEA;IACI,UAAU;AACd;AACA;IACI,aAAa;IACb,uBAAuB,EAAE,oCAAoC;IAC7D,mBAAmB,EAAE,kCAAkC;IACvD,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB,EAAE,kCAAkC;IACvD,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,uCAAuC;IACvC,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe,EAAE,+BAA+B;IAChD,mBAAmB,EAAE,4BAA4B;AACrD;;AAEA;IACI;QACI,YAAY;QACZ,mBAAmB;IACvB;IACA;QACI,eAAe,EAAE,+BAA+B;IACpD;IACA;QACI,kBAAkB;QAClB,cAAc;IAClB;AACJ","sourcesContent":["body {\r\n    font-family: Arial, sans-serif;\r\n    background-color: #f4f4f4;\r\n    color: aliceblue;\r\n    margin: 0;\r\n    padding: 0;\r\n    height: 100vh;\r\n    font-size: 15px;\r\n    font-weight: bold;\r\n    \r\n}\r\n\r\n.dot{\r\n    width: 30%;\r\n}\r\n.success_page {\r\n    display: flex;\r\n    justify-content: center; /* Horizontally center the content */\r\n    align-items: center; /* Vertically center the content */\r\n    height: 100vh;\r\n}\r\n\r\n.container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center; /* Vertically center the content */\r\n    background-color: #8c00ff;\r\n    border-radius: 10px;\r\n    padding: 50px 30px;\r\n    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);\r\n    max-width: 767px;\r\n    width: 100%;\r\n}\r\n\r\n.logo img {\r\n    width: 280px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.success_page h1 {\r\n    font-size: 28px; /* Adjust font size as needed */\r\n    margin-bottom: 10px; /* Optional: Adjust margin */\r\n}\r\n\r\n@media (max-width: 767.98px) {\r\n    .logo img {\r\n        width: 175px;\r\n        margin-bottom: 10px;\r\n    }\r\n    .success_page h1 {\r\n        font-size: 24px; /* Adjust font size as needed */\r\n    }\r\n    .success_page .container {\r\n        padding: 40px 15px;\r\n        max-width: 80%;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
